import React, { useContext } from 'react';
import { AppContext } from 'App.context';
import RoomDetail from './RoomDetail/RoomDetail';
import Colors from 'constants/Colors';
import CustomButton from 'Components/common/CustomButton/CustomButton';
import useSubHeaderHook from './SubHeader.hook';
import { ReactComponent as HotelIcon } from 'assets/images/hotel-icon.svg';
import { ReactComponent as Booking } from 'assets/images/booking.svg';

import './SubHeader.css';
import Loading from 'Components/common/Loader/Loading';

export default function SubHeader({ hotelName, showNext = true, nextText, onNext, isLoading }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);
  const { state, actions } = useSubHeaderHook();
  const { rooms, startDate, endDate } = state;
  return (
    <div className="info-panel">
      <div className="sub-header-icon">
        <HotelIcon />
      </div>
      <div className="sub-header-content">
        <div className="sub-header-title">{hotelName}</div>
        <div className="sub-header-description">
          {translate('createBooking.steps.selectRooms.bookingDate')}
          {': '}
          <span className="sub-header-description-value strong">
            {startDate} - {endDate}
          </span>
          <div className="sub-header-resume">
            {rooms &&
              Array.isArray(rooms) &&
              rooms.map(room => (
                <RoomDetail key={room.type} type={room.type} number={room.booked} />
              ))}
          </div>
        </div>
      </div>
      {showNext && (
        <div className="sub-header-button">
          <CustomButton
            text={nextText ?? translate('createBooking.continue')}
            background={Colors.blueColor}
            color={'white'}
            onClick={onNext}
            leftComponent={isLoading ? <Loading size="small" /> : <Booking />}
            noShadow={true}
            disabled={isLoading}
          ></CustomButton>
        </div>
      )}
    </div>
  );
}
